export enum DocType {
  APPLICATION_FORM = 'APPLICATION_FORM',
  BANK_STATEMENT = 'BANK_STATEMENT',
  CASE_SPREADSHEET = 'CASE_SPREADSHEET',
  CONVEYANCING = 'CONVEYANCING',
  CREDIT_REPORT = 'CREDIT_REPORT',
  DECISION_IN_PRINCIPLE = 'DECISION_IN_PRINCIPLE',
  FACT_FIND = 'FACT_FIND',
  FINANCIAL_INFORMATION_STATEMENT = 'FINANCIAL_INFORMATION_STATEMENT',
  ID_VERIFICATION = 'ID_VERIFICATION',
  OFFER_LETTER = 'OFFER_LETTER',
  PROOF_OF_IDENTITY = 'PROOF_OF_IDENTITY',
  PROOF_OF_DEPOSIT = 'PROOF_OF_DEPOSIT',
  PROOF_OF_INCOME = 'PROOF_OF_INCOME',
  RISK_AND_FEATURES = 'RISK_AND_FEATURES',
  SUITABILITY_LETTER = 'SUITABILITY_LETTER',
  TARIFF_LIST = 'TARIFF_LIST',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  VALUATION_REPORT = 'VALUATION_REPORT',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}
